import { render, staticRenderFns } from "./EmailContent.vue?vue&type=template&id=043da358&scoped=true&"
import script from "./EmailContent.vue?vue&type=script&lang=js&"
export * from "./EmailContent.vue?vue&type=script&lang=js&"
import style0 from "./EmailContent.vue?vue&type=style&index=0&id=043da358&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043da358",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
